<div
  class="error-modal"
  *ngIf="open && message"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'error-modal-title'"
>
  <div class="error-modal__panel">
    <header class="error-modal__head">
      <span class="error-modal__chip">
        <mat-icon>{{ visuals.icon }}</mat-icon>
        {{ visuals.subtitle }}
      </span>
      <button type="button" class="error-modal__close" (click)="close()" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="error-modal__body">
      <span class="error-modal__icon" aria-hidden="true">
        <mat-icon>{{ visuals.icon }}</mat-icon>
      </span>
      <h2 id="error-modal-title">{{ title }}</h2>
      <p class="error-modal__message">{{ message }}</p>
    </div>

    <footer class="error-modal__actions">
      <button type="button" class="error-modal__btn error-modal__btn--primary" *ngIf="showRetry" (click)="retry()">
        <mat-icon>refresh</mat-icon>
        Réessayer
      </button>
      <button
        type="button"
        class="error-modal__btn"
        [class.error-modal__btn--primary]="!showRetry"
        [class.error-modal__btn--ghost]="showRetry"
        (click)="close()">
        OK
      </button>
    </footer>
  </div>
</div>
